"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VSearchSelectAsyncSection = void 0;
var react_1 = __importStar(require("react"));
var EmptyData_1 = require("../../../SelectionList/EmptyData");
var SearchSelectItems_1 = require("../SearchSelect/SearchSelectItems");
var VSearchSelectFieldAsyncContext_1 = require("./context/VSearchSelectFieldAsyncContext");
var styled_1 = require("./styled");
var VSearchSelectAsyncSection = function (_a) {
    var id = _a.id, multi = _a.multi, allowEmpty = _a.allowEmpty;
    var _b = (0, react_1.useContext)(VSearchSelectFieldAsyncContext_1.VSearchSelectFieldAsyncContext), options = _b.options, selection = _b.selection, selectDeselectItem = _b.selectDeselectItem;
    if (!options.length) {
        return (react_1.default.createElement(styled_1.VSearchSelectSectionBody, null,
            react_1.default.createElement(EmptyData_1.EmptyData, { settings: {} })));
    }
    return (react_1.default.createElement(styled_1.VSearchSelectSectionBody, null,
        react_1.default.createElement(SearchSelectItems_1.SearchSelectItems, __assign({ key: "search-select-async-section-".concat(id) }, { options: options, selection: selection, multi: multi, selectDeselectItem: selectDeselectItem, allowEmpty: allowEmpty }, { allowNewItem: false }))));
};
exports.VSearchSelectAsyncSection = VSearchSelectAsyncSection;
